/*
 * File: redirect.ts
 * Project: meki
 * File Created: Monday, 21st December 2020 3:30:15 pm
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Friday, 12th February 2021 1:51:27 am
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */

interface RedirectParams {
  url: string;
  method: string;
  params: Record<string, string>;
}
export function redirect({ url, method, params }: RedirectParams): void {
  const form = document.createElement('form');
  form.style.display = 'none';
  form.method = method;
  form.action = url;
  Object.entries(params).forEach(([key, value]) => {
    const input = document.createElement('input');
    input.name = key;
    input.value = value;
    form.appendChild(input);
  });
  document.body.appendChild(form);
  form.submit();
}
